import { ProductsSearchContentStyled, ProductsSearchPanelStyled, ProductsSearchStyled } from './ProductsSearch.style';
import Overlay from 'components/Basic/Overlay/Overlay';
import { FilterPanel } from 'components/Blocks/Product/Filter/FilterPanel/FilterPanel';
import { SelectedFilters } from 'components/Blocks/Product/Filter/SelectedParameters/SelectedFilters';
import SortingBar from 'components/Blocks/SortingBar/SortingBar';
import { SearchProductsWrapper } from 'components/Pages/Search/SearchProductsWrapper';
import { useRef, useState } from 'react';
import { ListedProductConnectionPreviewType } from 'types/product';

type Props = {
    productsSearch: ListedProductConnectionPreviewType;
};

export const ProductsSearch: FC<Props> = ({ productsSearch }) => {
    const paginationScrollTargetRef = useRef<HTMLDivElement>(null);

    const [isPanelOpen, setIsPanelOpen] = useState(false);

    return (
        <ProductsSearchStyled ref={paginationScrollTargetRef}>
            {productsSearch.productFilterOptions !== null && (
                <>
                    {parseFloat(productsSearch.productFilterOptions.maximalPrice) !== 0 && (
                        <ProductsSearchPanelStyled>
                            <FilterPanel
                                totalCount={productsSearch.totalCount}
                                productFilterOptions={productsSearch.productFilterOptions}
                            />
                            {isPanelOpen && (
                                <Overlay isHiddenOnDesktop onClick={() => setIsPanelOpen((prev) => !prev)} />
                            )}
                        </ProductsSearchPanelStyled>
                    )}
                    <ProductsSearchContentStyled
                        isPanelActive={parseFloat(productsSearch.productFilterOptions.maximalPrice) !== 0}
                        ref={paginationScrollTargetRef}
                    >
                        <SelectedFilters filterOptions={productsSearch.productFilterOptions} />
                        <SortingBar sorting={productsSearch.orderingMode} totalCount={productsSearch.totalCount} />
                        <SearchProductsWrapper paginationScrollTargetRef={paginationScrollTargetRef} />
                    </ProductsSearchContentStyled>
                </>
            )}
        </ProductsSearchStyled>
    );
};
